import React from 'react';
import { Modal } from 'antd';

import { hasPermissions } from 'helpers/permissionsHelpers';

/**
 * Show informative modal
 * @param {string} title
 * @param {string} message
 * @param {history object} history
 * @param {string} redirection
 * @param {string} modalType -> can only be success, info, warning or error.
 */
const modalInfo = (title, message, history, redirection, modalType) =>
  Modal[modalType]({
    title,
    content: (
      <div>
        <p>{message}</p>
      </div>
    ),
    onOk () {
      history.push(redirection);
    },
  });

export const getCustomModalProps = (
  permissions,
  editable,
  isActivitySelected = false,
  handleMapCancel,
  handleMapSubmit,
  handleMapValid,
) => {
  const canValid = hasPermissions(permissions, ['trrequests.can_internal_comment_requests'])
  && hasPermissions(permissions, ['trrequests.can_comment_requests']);

  if (canValid) {
    return {
      title: <h3>Proposer / valider un tracé</h3>,
      buttons: [
        {
          label: 'Fermer',
          action: handleMapCancel,
          type: 'default',
        },
        {
          label: 'Proposer',
          action: handleMapSubmit,
          type: 'primary',
        },
        {
          label: 'Imposer',
          action: handleMapValid,
          type: 'primary',
        },
      ],
      editable: true,
    };
  }

  if (editable) {
    return {
      title: <h3>Proposer un parcours</h3>,
      buttons: [
        {
          label: 'Abandonner',
          action: handleMapCancel,
          type: 'default',
        },
        {
          label: 'Soumettre',
          action: handleMapSubmit,
          type: 'primary',
        },
      ],
      editable: true,
      okButtonProps: { disabled: !isActivitySelected },
    };
  }

  return {
    footer: null,
    editable: false,
  };
};

export default modalInfo;



// WEBPACK FOOTER //
// ./src/helpers/modalHelpers.js